import { HistoricoAnalisePosturalItem } from './../../../dto/movia/HistoricoAnalisePostural';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MoviaService } from './../../../services/movia/movia.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import axios from 'axios';

@Component({
  selector: 'app-historico-analise-postural',
  imports: [
    MatTableModule,
    CommonModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule, 
    MatIconModule,   
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    MatSortModule,
    MatTooltipModule,
    MatIconModule,
  ],
  templateUrl: './historico-analise-postural.html',
  styleUrl: './historico-analise-postural.scss',
})
export class HistoricoAnalisePostural implements OnInit {
  displayedColumns = [
    'nomeArquivo',
    'dataProcessamento',
    'nomePessoa',
    'status',
    'acoes',
  ];

  dataSource = new MatTableDataSource<HistoricoAnalisePosturalItem>([]);
  historico: HistoricoAnalisePosturalItem[] = [];

  filtroTexto = '';
  isLoading = false;

  total = 0;
  pageSize = 10;
  pageSizeOptions = [10, 20, 50];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private moviaService: MoviaService) {}

  async ngOnInit() {
    await this.buscarHistorico();
  }

  async buscarHistorico() {
    this.isLoading = true;

    try {
      const data = await this.moviaService.buscarHistorico();
      this.historico = data;

      this.dataSource = new MatTableDataSource(this.historico);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.total = this.historico.length;

      this.dataSource.filterPredicate = (item, filter) => {
        const texto = filter.trim().toLowerCase();
        return (
          item.nomeArquivo?.toLowerCase().includes(texto) ||
          item.dataProcessamento?.toString().includes(texto) ||
          item.nomePessoa?.toLowerCase().includes(texto) ||
          item.status?.toLowerCase().includes(texto)
        );
      };
    } catch (error) {
      console.error('Erro ao buscar histórico de importação:', error);
    } finally {
      this.isLoading = false;
    }
  }

  aplicarFiltro() {
    this.dataSource.filter = this.filtroTexto.trim().toLowerCase();
    this.total = this.dataSource.filteredData.length;
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
  }

  get textoContagem(): string {
    return `Mostrando ${this.dataSource.filteredData.length} de ${this.historico.length}`;
  }
   // ── Exportação ────────────────────────────────────────────

  async baixarRelatorio(correlationId: string): Promise<void> {
    this.isLoading = true; // Feedback visual
    try {
      await this.moviaService.baixarRelatorio(correlationId);
    } catch (error) {
      axios('Erro ao gerar o relatório. Verifique se você tem permissão.');
    } finally {
      this.isLoading = false;
    }
  }
}
